import _ from "lodash";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import { ServiceThreadSpinner, TopCustomersBySalesGrid } from ".";
import { api, constants, dateHelpers, helpers } from "../utils";

export default function TopCustomersBySales(props) {
  const [data, setData] = useState();
  const [loaded, setLoaded] = useState(false);
  // const [page, setPage] = useState(1);
  const [salespersonId, setSalespersonId] = useState(props.salespersonId);
  const [sortDirection, setSortDirection] = useState(" Desc");
  const [sortField, setSortField] = useState("CurrentSales");

  let startDate = new Date();
  startDate.setFullYear(startDate.getFullYear() - 1); // take off one year
  let endDate = new Date();
  let previousStartDate = new Date();
  previousStartDate.setFullYear(previousStartDate.getFullYear() - 2);
  previousStartDate.setDate(previousStartDate.getDate() - 1); // take off one day
  let previousEndDate = new Date();
  previousEndDate.setFullYear(previousEndDate.getFullYear() - 1);
  previousEndDate.setDate(previousEndDate.getDate() - 1); // take off one day

  useEffect(() => {
    if (props.salespersonId !== salespersonId) {
      setSalespersonId(props.salespersonId);
      setLoaded(false);
    }
    if (!loaded) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded, props.salespersonId]);

  function createPayload() {
    return {
      StartDate: dateHelpers.formatDateForServer(startDate),
      EndDate: dateHelpers.formatDateForServer(endDate),
      PreviousStartDate: dateHelpers.formatDateForServer(previousStartDate),
      PreviousEndDate: dateHelpers.formatDateForServer(previousEndDate),
      ClassList: props.classList,
      SalesPersonId: props.salespersonId,
      PageSize: 10,
      MaxRows: 25,
      ItemNumber: "",
      SortField: sortField,
      SortDirection: sortDirection,
    };
  }

  function exportXlsx() {
    const payload = createPayload();
    api
      .postGetBlob("Customer/ExportTopCustomersXLSX", payload)
      .then((r) => {
        if (r.data.success === false) {
          if (_.isString(r?.data?.message)) {
            toast.error(r?.data?.message);
          }
          return;
        }
        if (r.data) {
          const XLSX_FILENAME = payload.SalesPersonId.length > 0 ? `TopCustomers_${payload.SalesPersonId}.xlsx` : `TopCustomers.xlsx`;
          helpers.downloadExport(
            r.data,
            XLSX_FILENAME,
            constants.MIME_TYPES.xlsx
          );
        } else {
          toast.error(r.message || "Error downloading report");
        }
      })
      .catch(api.catchHandler);
  }

  function loadData() {
    api
      .post(`Sales/GetTop25SalesAnalysisCompanyLevel`, createPayload())
      .then((response) => {
        if (response.data.success) {
          setData(response.data.SalesAnalysisInfo);
        }
        setLoaded(true);
      })
      .catch(api.catchHandler);
  }

  function onPageChange(page) {
    // setPage(page);
    setLoaded(false);
  }

  function onSortChange(field, direction) {
    if (field !== sortField) {
      setSortField(field);
      setSortDirection("asc");
    } else {
      setSortDirection(direction);
    }
    onPageChange(1);
  }

  return (
    <React.Fragment>
      <div>
        <span className="h2 me-2">Top 25 Customers by Sales Last 365 Days</span>
      </div>
      <hr />
      <ServiceThreadSpinner on={!loaded}>
        <Row className="px-4">
          <Col xs={12}>
            <Row>
              <p className="m-1">
                <strong>Current Sales Period </strong>
                {dateHelpers.toLongDateString(startDate) +
                  " - " +
                  dateHelpers.toLongDateString(endDate)}
              </p>
            </Row>
            <Row>
              <p className="m-1">
                <strong>Previous Sales Period </strong>
                {dateHelpers.toLongDateString(previousStartDate) +
                  " - " +
                  dateHelpers.toLongDateString(previousEndDate)}
              </p>
            </Row>
          </Col>
        </Row>
        {data && data.items && data.items.length > 0 ? (
          <TopCustomersBySalesGrid
            data={data}
            sortCallback={onSortChange}
            sortField={sortField}
            sortDirection={sortDirection}
            exportXlsxCallback={exportXlsx}
          />
        ) : null}
      </ServiceThreadSpinner>
    </React.Fragment>
  );
}
